import { FormItemProps } from 'antd';

export class OfflineTimeService {
  static isCallChanged: FormItemProps['shouldUpdate'] = (prev, curr) => prev.startTime !== curr.startTime
    || prev.endTime !== curr.endTime
    || prev.offlineActivities?.length !== curr.offlineActivities?.length;
}
